import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { Root } from "@definitions";
import { DecimalInputNode } from "src/definitions/ui-definitions";
import { DecimalInput } from "src/ui/components/widgets/decimal-input/decimal-input";

export type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	DecimalInputNode
>;

export class DecimalInputComponentBuilder
	implements UiComponentBuilder<Root, DecimalInputNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(node: DecimalInputNode, context: UiComponentBuildContext<Root>) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
					write
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node, context)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node, context);
		}
	}

	private _render(
		node: DecimalInputNode,
		_: UiComponentBuildContext<Root>,
	): ReactElement {
		return <DecimalInput id={node.id} min={node.min} max={node.max} />;
	}
}
